<template>
  <div>
    <vs-tabs :value="tabIndex">
      <vs-tab v-for="(tab, index) in tabList"
              :key="index"
              :label="tab.name"
              @click="moveTab(tab.boardSlug)"
      >
        <component :is="getComponent(tab.boardSlug)"/>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import ApprovalDocument from '@/views/write/document/ApprovalDocument'
import AccidentReportIndex from '@/views/write/accident/AccidentReportIndex'
import AccidentReviewIndex from '@/views/write/accident/AccidentReviewIndex'
import AccidentStatisticsIndex from '@/views/write/accident/AccidentStatisticsIndex'
import WriteSafetyCheck444Index from '@/views/write/safetycheck/SafetyCheck444Index'
import FireFightingSelfCheck from '@/views/write/safetycheck/firefighting_self_check/FireFightingSelfCheck'
import ElectricalEquipmentCheck from '@/views/write/safetycheck/electrical_equipment_check/ElectricalEquipmentCheck'
import ElevatorSafetyCheck from '@/views/write/safetycheck/elevator_safety_check/ElevatorSafetyCheck'
import WaterTankHygieneCheck from '@/views/write/safetycheck/water_tank_hygiene_check/WaterTankHygieneCheck'
import GasPressureCheck from '@/views/write/safetycheck/gas_pressure_check/GasPressureCheck'
import PeriodicSafetyCheckBuilding
  from '@/views/write/safetycheck/periodic_safety_check_building/PeriodicSafetyCheckBuilding'

export default {
  name: 'ReportWrite',
  components: {
    PeriodicSafetyCheckBuilding,
    GasPressureCheck,
    WaterTankHygieneCheck,
    ElevatorSafetyCheck,
    ElectricalEquipmentCheck,
    FireFightingSelfCheck,
    WriteSafetyCheck444Index,
    AccidentStatisticsIndex,
    AccidentReviewIndex,
    AccidentReportIndex,
    ApprovalDocument},
  computed:{
    tabList () {
      return [
        { name: '소방시설 자체 점검결과 보고서', boardSlug: 'firefighting_self_check'}, // 완
        { name: '전기시설 점검', boardSlug: 'electrical_equipment_check'}, // 완
        { name: '가스 압력상태 점검', boardSlug: 'gas_pressure_check'},
        { name: '승강기 안전 점검', boardSlug: 'elevator_safety_check'},
        { name: '저수조 위생 점검', boardSlug: 'water_tank_hygiene_check'},
        { name: '정기안전점검(건축물)', boardSlug: 'periodic_safety_check_building'},
      ]
    },
    tabIndex () {
      let i = 0
      for (i = 0; i < this.tabList.length; i++) {
        const tab = this.tabList[i]
        if (this.boardSlug === tab.boardSlug) {
          return i
        }
      }
      return 0
    },
    boardSlug () {
      return this.$route.params.boardSlug
    }
  },
  created () {
    let breadcrumb = [
      {title: 'Home'},
      {title: '안전점검'},
      {
        title: '안전점검',
        active: true
      }
    ]

    if (this.boardSlug === 'safety_check_partner_444') {
      breadcrumb = [
        {title: 'Home'},
        {title: '파트너사 일일보고'},
        {
          title: '안전점검',
          active: true
        }
      ]
    }

    this.$store.commit('menu/UPDATE_PAGE_LIST', breadcrumb)
  },
  mounted () {
  },
  methods: {
    moveTab (boardSlug) {
      this.$router.push({name:'list|approval_tab_list|safety_check', params:{boardSlug}})
    },
    getComponent (boardSlug) {
      if (boardSlug === 'firefighting_self_check') return 'FireFightingSelfCheck'
      else if (boardSlug === 'electrical_equipment_check') return 'ElectricalEquipmentCheck'
      else if (boardSlug === 'gas_pressure_check') return 'GasPressureCheck'
      else if (boardSlug === 'elevator_safety_check') return 'ElevatorSafetyCheck'
      else if (boardSlug === 'water_tank_hygiene_check') return 'WaterTankHygieneCheck'
      else if (boardSlug === 'periodic_safety_check_building') return 'PeriodicSafetyCheckBuilding'

      return 'WriteSafetyCheck444Index'
    }
  }
}
</script>

<style scoped>

</style>
